import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Modal, Button, Form, Select, Input, Spin} from 'antd'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import style from './modal.sass'

@inject('store') @observer
class SignalModal extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.props.store.signal.getPart()
      document.addEventListener('keypress', this.keypressHandler)
      setTimeout(() => {
        var firstInput = document.querySelector('.modal input')
        if (firstInput && firstInput.focus) {
          firstInput.focus()
        }
      }, 300)
    }
    if (!this.props.visible && prevProps.visible) {
      document.removeEventListener('keypress', this.keypressHandler)
    }
  }
  componentWillUnmount() {
    document.removeEventListener('keypress', this.keypressHandler)
  }
  showAdditional = () => {
    this.props.store.signal.showAdditional()
  }
  keypressHandler = (e) => {
    if (e.keyCode === 13) {
      this.insert()
    }
  }
  insert = () => {
    this.props.store.signal.insert()
  }
  searchTickers = (value) => {
    this.props.store.symbols.search(value)
  }
  handleCancel = () => {
    this.props.store.signal.insert(false)
    this.props.hide()
  }
  getParams = (array, validationErrors) => array.map(param => {
    const {symbols} = this.props.store
    const hasError = validationErrors.indexOf(param.name) !== -1
    return(
      <Form.Item
        label={param.name}
        validateStatus={hasError ? 'error' : null}
        help={hasError ? 'This field is required' : null}
        key={param.name}
      >
        {param.options
          ? <div>
            {param.hasNumberInput &&
              <Input
                style={{width:75}}
                required={true}
                name={`${param.name}-number`}
                type='number'
                onChange={(e) => param.changeValue(e.target.value, true)}
                value={param.additionalValue}
              />
            }
            <Select
              onChange={(value) => param.changeValue(value, false)}
              onFocus={() => param.removeValidationError()}
              value={param.hasNumberInput ? param.selectWithNumber : param.value}
              style={{minWidth:125}}
              placeholder={param.default_value ? param.ident === 'NUM_DAYS' ? `${param.default_value} days` : param.default_value : ''}
            >
              {param.options.map(opt =>
                <Select.Option key={opt} value={opt}>
                  {param.additionalValue && param.additionalValue < 2000 ?
                    opt.replace('X', param.additionalValue)
                    :
                    opt
                  }
                </Select.Option>
              )}
            </Select>
          </div>
          : param.ident === 'TICKER'
            ? <Select
              showSearch={true}
              onChange={(value) => param.changeValue(value, false)}
              filterOption={false}
              onSearch={(value) => this.searchTickers(value)}
              onFocus={() => param.removeValidationError()}
              value={param.value}
              style={{minWidth:125}}
              notFoundContent={symbols.searching ? <Spin size="small" /> : null}
              dropdownMatchSelectWidth={false}
            >
              {symbols.list.map(sym =>
                <Select.Option key={sym.symbol} value={sym.symbol.indexOf('CRYPTO-') !== -1 ? sym.symbol.slice(7) : sym.symbol}>
                  {sym.symbol}{sym.symbol_name ? ` - ${sym.symbol_name}` : ''}
                </Select.Option>
              )}
            </Select>
            : <Input
              style={{paddingBottom:5}}
              required={param.is_required}
              name={param.name}
              type={param.kind}
              onChange={(e) => param.changeValue(e.target.value, false)}
              onFocus={() => param.removeValidationError()}
              value={param.value}
              placeholder={param.default_value}
            />
        }
      </Form.Item>
    )
  })

  render() {
    const {signal} = this.props.store
    const {part, validationErrors} = signal
    if (!part) {
      return null
    }
    return(
      <Modal
        visible={this.props.visible}
        onOk={this.insert}
        onCancel={this.handleCancel}
        className={style.wrapper}
        footer={<div className={style.footer}>
          {!!part.additionalParams.length && !signal.additional &&
            <a onClick={this.showAdditional} className={style['indicator-settings']}>
              <FontAwesomeIcon icon='cog'/> Indicator Settings
            </a>
          }
          <Button onClick={this.handleCancel}>Cancel</Button>
          <Button type='primary' onClick={this.insert}>Insert</Button>
        </div>}
      >
        <Form>
          <div className={style.default}>
            {this.getParams(part.defaultParams, validationErrors)}
            <h4>{part.syntax}</h4>
          </div>
          {signal.additional &&
            <div className={style.additional}>
              {this.getParams(part.additionalParams, validationErrors)}
            </div>
          }
        </Form>
      </Modal>
    )
  }
}

export default SignalModal
